import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from '../../lib/icons';
import { PaelbiLogo } from '../common/Logo';
import { Button } from '../common/Button';
import { GuestNavLinks } from './GuestNavLinks';
import { LanguageSelector } from './LanguageSelector';
import { useLanguage } from '../../context/LanguageContext';
import { useTenantBase } from '../../lib/tenantPath';

export function PaelbiHeader() {
  const [open, setOpen] = useState(false);
  const { lang, setLang, languages, t } = useLanguage();
  const location = useLocation();
  const base = useTenantBase();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-paelbi-line/70 bg-paelbi-bg/90 backdrop-blur-md">
      <div className="mx-auto flex h-[72px] max-w-container items-center justify-between px-6">
        {/* Logo left */}
        <Link to={base} aria-label="PAELBI home" className="shrink-0">
          <PaelbiLogo />
        </Link>

        {/* Menu centered */}
        <nav className="hidden lg:flex items-center gap-7 absolute left-1/2 -translate-x-1/2">
          <GuestNavLinks variant="desktop" />
        </nav>

        {/* Right actions */}
        <div className="flex items-center gap-3">
          <LanguageSelector
            className="hidden sm:block"
            value={lang.toUpperCase()}
            languages={languages.map((l) => l.toUpperCase())}
            onChange={(l) => setLang(l.toLowerCase())}
          />

          <Button to={`${base}/info-bnb`} variant="primary" iconLeft="user" className="hidden sm:inline-flex h-11 px-5 text-sm">
            {t('Il mio soggiorno')}
          </Button>

          <button
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-btn text-paelbi-brown"
            aria-label={open ? 'Chiudi menu' : 'Apri menu'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <Icon name={open ? 'close' : 'menu'} size={26} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-paelbi-line bg-paelbi-bg">
          <nav className="mx-auto flex max-w-container flex-col px-6 py-4">
            <GuestNavLinks variant="mobile" />
            <div className="mt-4 flex items-center justify-between">
              <div className="flex items-center gap-1.5 text-sm text-paelbi-ink/80">
                <Icon name="globe" size={18} />
                <span>{lang.toUpperCase()}</span>
              </div>
              <Button to={`${base}/info-bnb`} variant="primary" iconLeft="user" className="h-11 px-5 text-sm">
                {t('Il mio soggiorno')}
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}

export default PaelbiHeader;
